import routes from '../routes';
import { useState } from 'react';
import Logo from '../assets/logo.png';
import { makeStyles } from '@mui/styles';
import { FaImage } from "react-icons/fa6";
import { FaUsers } from "react-icons/fa6";
import { IoLogOut } from "react-icons/io5";
import { GrGallery } from "react-icons/gr";
import { FaUserPlus } from "react-icons/fa";
import { MdContacts } from "react-icons/md";
import { RiAdminFill } from "react-icons/ri";
import { MdDashboard } from "react-icons/md";
import { MdEventSeat } from "react-icons/md";
import { IoIosCreate } from "react-icons/io";
import { MdRateReview } from "react-icons/md";
import { FaCarTunnel } from "react-icons/fa6";
import { FaUserFriends } from "react-icons/fa";
import { MdOutlineMenu } from "react-icons/md";
import { logout } from '../redux/auth/auth.slice';
import { MdKeyboardArrowDown } from "react-icons/md";
import { Link, useNavigate } from 'react-router-dom';
import { RiQuestionAnswerFill } from "react-icons/ri";
import { useDispatch, useSelector } from 'react-redux';
import { setActiveLink } from '../redux/event/event.slice';
import { MdOutlineSend } from "react-icons/md"; // Added icon for Send Communication


const useStyles = makeStyles({
    name: {
        color: "#fff",
        textTransform: "capitalize",
        background: "none",
        border: "none",
        fontWeight: "bold",
        fontSize: "18px"
    },
    dropdown: {
        right: 0,
        zIndex: 10,
        position: "absolute",
        background: "#fff",
        borderRadius: "4px",
        width: "100%",
        padding: "4px 0"
    }
});

const PrimaryHeader = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [isDropdown, setIsDropdown] = useState(false);
    const { admin } = useSelector((state) => state.auth);
    const { activeLink } = useSelector((state) => state.event);

    const logoutClicked = () => {
        dispatch(logout());
        dispatch(setActiveLink("Events"));
        navigate("/");
    }

    const sideLink = [
        {
            name: "Dashboard",
            icon: MdDashboard,
            routeTo: routes.dashboard
        },
        {
            name: "Events",
            icon: MdEventSeat,
            routeTo: routes.home
        },
        {
            name: "Users",
            icon: FaUsers,
            routeTo: routes.user_list
        },
        {
            name: "Orders",
            icon: FaCarTunnel,
            routeTo: routes.order_list
        },
        {
            name: "Founders",
            icon: FaUserFriends,
            routeTo: routes.founder_list
        },
        {
            name: "Gallery",
            icon: GrGallery,
            routeTo: routes.gallery
        },
        {
            name: "Partners",
            icon: FaUserPlus,
            routeTo: routes.partners
        },
        {
            name: "Reviews",
            icon: MdRateReview,
            routeTo: routes.reviews
        },
        {
            name: "Contact Us",
            icon: MdContacts,
            routeTo: routes.contact_us_list
        },
        {
            name: "Send Communication",
            icon: MdOutlineSend,
            routeTo: routes.send_communication
        },
        {
            icon: RiQuestionAnswerFill,
            name: "Question Answer",
            routeTo: routes.question_answer
        },
        {
            icon: FaImage,
            name: "Header Image",
            routeTo: routes.header_image
        }
    ];

    return (
        <>
            <nav className="navbar navbar-dark fixed-top bg-custom">
                <div className="container-fluid">
                    <div className="d-flex align-items-center">
                        <button className="navbar-toggler shadow-none" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                            <MdOutlineMenu fontSize="xx-large" />
                        </button>
                        <span className={classes.name}>{activeLink}</span>
                    </div>
                    {/* <h4 className={classes.Heading}>Welcome Admin!</h4> */}
                    <div className="position-relative">
                        <button
                            type="button"
                            className={classes.name}
                            onClick={() => setIsDropdown(!isDropdown)}>
                            Welcome {admin?.name} <MdKeyboardArrowDown />
                        </button>
                        {isDropdown && 
                            <div className={classes.dropdown}>
                                <ul className="dropdown-list">
                                    <li onClick={logoutClicked}>
                                        <IoLogOut fontSize="large" />{" "}
                                        <span className="ml-4 fw-bold">Logout</span>
                                    </li>
                                </ul>
                            </div>
                        }
                    </div>
                </div>
            </nav>
            <div className="offcanvas offcanvas-start" tabIndex="-1" id="offcanvasExample" aria-labelledby="offcanvasExampleLabel">
                <div className="offcanvas-header">
                    <img src={Logo} alt="Logo" width="44" />
                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                </div>
                <div className="offcanvas-body">
                    <div className="d-flex justify-content-center event-box">
                        <Link
                            data-bs-dismiss="offcanvas"
                            to={routes.create_new_event}
                            onClick={() => dispatch(setActiveLink("Create New Event"))}
                            className="btn btn-outline-primary primary-button d-flex align-items-center"
                        >
                            <IoIosCreate fontSize="large" />
                            Create New Event
                        </Link>
                        {/* <Link 
                            onClick={() => dispatch(setActiveLink("Event Template"))}
                            data-bs-dismiss="offcanvas"
                            className="btn btn-outline-primary primary-button"
                            to={routes.event_template}>
                            Event Template
                        </Link> */}
                    </div>
                    <div className="dropdown mt-2 side-menu">
                        <ul>
                            {sideLink.map((item, index) => (
                                <li
                                    key={index}
                                    onClick={() => dispatch(setActiveLink(item.name))}
                                    className={item.name === activeLink ? 'active-link' : 'inactive-link'}
                                >
                                    <Link
                                        to={item.routeTo}
                                        data-bs-dismiss="offcanvas"
                                        className={item.name === activeLink ? 'active-link' : 'inactive-link'}
                                    >
                                        <item.icon 
                                        
                                        />
                                        {item.name}
                                    </Link>
                                </li>
                            ))}
                            {(admin?.email === "admin@thriftyx.com" ||
                                admin?.email === "admin@gmail.com") &&
                                <li
                                    key={sideLink?.length}
                                    onClick={() => dispatch(setActiveLink("Sub Admin"))}
                                    className={activeLink === "Sub Admin" ? 'active-link' : 'inactive-link'}
                                >
                                    <Link
                                        to={routes.sub_admin_list}
                                        data-bs-dismiss="offcanvas"
                                        className={activeLink === "Sub Admin" ? 'active-link' : 'inactive-link'}
                                    >
                                        <RiAdminFill />
                                        Sub Admin
                                    </Link>
                                </li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PrimaryHeader;